<script>
const routes = [
	{
		path: '*',
		redirect: '/inits'
	},
	// 引导页
	{
		path: '/inits',
		name: '引导页',
		component: () => import('@/homesview/inits.vue'),
		meta: {
			isallmain: 1
		}
	},
	// 金砖大赛
	{
		path: '/match',
		name: '金砖大赛',
		component: () => import('@/homesview/Oldcompetitions.vue'),
		meta: {
			isallmain: 1
		}
	},
	// 智能运维
	{
		path: '/maintenance/Index',
		name: '智能运维平台',
		component: () => import('@/pageme/maintenance.vue'),
		meta: {
			isallmain: 1
		}
	},

	// 门户网站
	{
		path: '/homesview/homesview',
		name: '云首页',
		component: () => import('@/homesview/homesview.vue'),
		meta: {
			isallmain: 1
		}
	},
	// {
	// 	path: '/pageme/text',
	// 	name: '测试',
	// 	component: () => import('@/pageme/text.vue'),
	// 	meta: {
	// 		isallmain: 1
	// 	}
	// },

	{
		path: '/homesview/cloudcourse',
		name: '云课程',
		component: () => import('@/homesview/cloudcourse.vue'),
		meta: {
			isallmain: 1
		}
	},
	{
		path: '/homesview/resource',
		name: '资源库',
		component: () => import('@/homesview/resource.vue'),
		meta: {
			isallmain: 1
		}
	},
	{
		path: '/homesview/trialballoon',
		name: '试题库',
		component: () => import('@/homesview/trialballoon.vue'),
		meta: {
			isallmain: 1
		}
	},
	// {
	// 	path: '/homesview/competition',
	// 	name: '金砖大赛',
	// 	component: () => import('@/homesview/competition.vue'),
	// 	meta: {
	// 		isallmain: 1
	// 	}
	// },
	{
		path: '/cours/clouddetea',
		name: '课程详情',
		component: () => import('@/homesview/cours/clouddetea.vue'),
		meta: {
			isallmain: 1
		}
	},
	{
		path: '/resource/resourcedetils',
		name: '资源详情',
		component: () => import('@/homesview/resource/resourcedetils.vue'),
		meta: {
			isallmain: 1
		}
	},
	{
		path: '/testists/testdelites',
		name: '试题详情',
		component: () => import('@/homesview/testists/testdelites.vue'),
		// 将参数解析为数字
		props: route => ({ id: Number(route.params.id), pro_guid: route.params.pro_guid, IL_GUID: route.params.IL_GUID, PR_GUID: route.params.PR_GUID }),
		meta: {
			isallmain: 1
		}
	},

	{
		path: '/testists/coursetestdelites',
		name: '章节练习',
		component: () => import('@/homesview/testists/coursetestdelites.vue'),
		meta: {
			isallmain: 1
		}
	},
	// 任务考核
	{
		path: '/assessmenttask/Assessmenttaskmange',
		name: '任务考核管理',
		component: () => import('@/pageme/Assessmenttask/Assessmenttaskmange.vue')
	},
	{
		path: '/assessmenttask/Assessmenttaskxq',
		name: '任务考核详情',
		component: () => import('@/pageme/Assessmenttask/Assessmenttaskxq.vue')
	},
	{
		path: '/assessmenttask/Assessmenttaskuserenter',
		name: '1X报名',
		component: () => import('@/pageme/Assessmenttask/Assessmenttaskuserenter.vue')
	},
	{
		path: '/assessmenttask/Assessmenttaskuser',
		name: '我的考核',
		component: () => import('@/pageme/Assessmenttask/Assessmenttaskuser.vue')
	},
	// 云学习平台
	// 考试
	{
		path: '/homesview/examinationmanage/examine',
		name: '模拟考试',
		component: () => import('@/homesview/examinationmanage/examine.vue')
	},

	// 资源管理
	{
		path: '/resources/resource/resourcemanage',
		name: '资源管理',
		component: () => import('@/homesview/resource/resourcemanage.vue')
	},
	{
		path: '/resources/resource/uploadresour',
		name: '上传资源',
		component: () => import('@/homesview/resource/uploadresour.vue')
	},
	{
		path: '/resources/resource/mediatype',
		name: '媒体类型管理',
		component: () => import('@/homesview/resource/mediatype.vue')
	},
	{
		path: '/textorexamin/examinationmanage/examinationmanage',
		name: '试卷管理',
		component: () => import('@/homesview/examinationmanage/examinationmanage.vue')
	},
	{
		path: '/textorexamin/examinationmanage/mark',
		name: '成绩管理',
		component: () => import('@/homesview/examinationmanage/mark.vue')
	},
	{
		path: '/course/cours/coursemanagement',
		name: '课程管理',
		component: () => import('@/homesview/cours/coursemanagement.vue')
	},
	{
		path: '/course/cours/addcourse',
		name: '添加课程',
		component: () => import('@/homesview/cours/addcourse.vue')
	},
	{
		path: '/course/cours/courseapplication',
		name: '课程申请管理',
		component: () => import('@/homesview/cours/courseapplication.vue')
	},
	{
		path: '/studyplan/learningmap/learningmap',
		name: '学习地图管理',
		component: () => import('@/homesview/learningmap/learningmap.vue')
	},
	{
		path: '/studyplan/learningmap/allocation',
		name: '学习地图分配',
		component: () => import('@/homesview/learningmap/allocation.vue')
	},
	{
		path: '/textorexamin/testists/questionbank',
		name: '题库管理',
		component: () => import('@/homesview/testists/questionbank.vue')
	},
	{
		path: '/textorexamin/testists/trainingstrategy',
		name: '训练策略',
		component: () => import('@/homesview/testists/trainingstrategy.vue')
	},
	{
		path: '/textorexamin/testists/importthetopic',
		name: '导入题目',
		component: () => import('@/homesview/testists/importthetopic.vue')
	},
	{
		path: '/basicmanage/testists/knowledgecategory',
		name: '知识类别管理',
		component: () => import('@/homesview/testists/knowledgecategory.vue')
	},
	{
		path: '/basicmanage/testists/assessmentlevel',
		name: '考核等级管理',
		component: () => import('@/homesview/testists/assessmentlevel.vue')
	},
	{
		path: '/basicmanage/testists/station',
		name: '岗位管理',
		component: () => import('@/homesview/testists/station.vue')
	},
	{
		path: '/system/testists/information',
		name: '消息管理',
		component: () => import('@/homesview/testists/information.vue')
	},
	{
		path: '/system/testists/informationtype',
		name: '消息类型管理',
		component: () => import('@/homesview/testists/informationtype.vue')
	},
	{
		path: '/usercenter/mycourse',
		name: '我的课程',
		component: () => import('@/homesview/mycourse.vue')
	},
	{
		path: '/usercenter/mytraining',
		name: '我的训练',
		component: () => import('@/homesview/mytraining.vue')
	},
	{
		path: '/allmanage/Trainingrecords',
		name: '训练记录',
		component: () => import('@/homesview/Trainingrecords.vue')
	},
	{
		path: '/studyplan/Learnaboutmap',
		name: '学习地图执行情况管理',
		component: () => import('@/homesview/Learnaboutmap.vue')
	},
	// 我新增的组件
	// 用户注册登录
	{
		path: '/user/logins',
		name: '登录',
		component: () => import('@/pageme/Userlogin.vue')
	},
	{
		path: '/user/register',
		name: '注册',
		component: () => import('@/pageme/register.vue')
	},
	{
		path: '/datawall/schooldata',
		name: '数据分析',
		component: () => import('@/pageme/datawall/schooldata.vue')
	},
	{
		path: '/datawall/driveschooldata',
		name: '模拟驾驶数据分析',
		component: () => import('@/pageme/datawall/driveschooldata.vue')
	},
	{
		path: '/datawall/driveschooldatauser',
		name: '学员实训画像',
		component: () => import('@/pageme/datawall/driveschooldatauser.vue')
	},
	{
		path: '/user/foundpass',
		name: '找回密码',
		component: () => import('@/pageme/foundpass.vue')
	},
	{
		path: '/user/ChangeUser',
		name: '修改个人信息',
		component: () => import('@/pageme/user/ChangeUser.vue')
	},
	// {
	// 	path: '/user/opensell',
	// 	name: '打开信息',
	// 	component: () => import('@/pageme/user/opensell.vue')
	// },
	{
		path: '/user/weekdata',
		name: '日历信息',
		component: () => import('@/pageme/Calendar.vue')
	},

	{
		path: '/home',
		name: '首页',
		component: () => import('@/pageme/home.vue')
	},
	// 学生端
	{
		path: '/studenthome',
		name: '学生端首页',
		component: () => import('@/studentview/home/studenthome.vue')
	},
	{
		path: '/usercenter/studenthome',
		name: '学生端首页1',
		component: () => import('@/studentview/home/studenthome.vue')
	},
	{
		path: '/usercenter/usermessage',
		name: '学生端个人信息',
		component: () => import('@/studentview/usercenter/usermessage.vue')
	},
	{
		path: '/usercenter/mypromise',
		name: '我要预约',
		component: () => import('@/studentview/usercenter/mypromise.vue')
	},
	{
		path: '/usercenter/myuserpromise',
		name: '我的预约',
		component: () => import('@/studentview/usercenter/myuserpromise.vue')
	},
	{
		path: '/usercenter/myrealtest',
		name: '我的实训',
		component: () => import('@/studentview/usercenter/myrealtest.vue')
	},
	{
		path: '/usercenter/myrealtestchart',
		name: '实训详情',
		component: () => import('@/studentview/usercenter/myrealtestchart.vue')
	},
	// 用户信息管理
	{
		path: '/basicmanage/manage',
		name: '用户管理',
		component: () => import('@/pageme/Usermanage/mange.vue')
	},
	{
		path: '/basicmanage/attendanceCertification',
		name: '考勤认证',
		component: () => import('@/pageme/Usermanage/attendanceCertification.vue')
	},
	{
		path: '/basicmanage/appenduser',
		name: '添加用户',
		component: () => import('@/pageme/Usermanage/appenduser.vue')
	},
	{
		path: '/basicmanage/Usertypemanage',
		name: '用户类型管理',
		component: () => import('@/pageme/Usermanage/Usertypemanage.vue')
	},

	{
		path: '/basicmanage/shoolmanage',
		name: '院校管理',
		component: () => import('@/pageme/Qitamanage/shoolmanage.vue')
	},
	{
		path: '/system/menumange',
		name: '菜单管理1',
		component: () => import('@/pageme/Qitamanage/menumange.vue')
	},
	{
		path: '/Usermanage/menumange',
		name: '菜单管理3',
		component: () => import('@/pageme/Qitamanage/menumange.vue')
	},
	{
		path: '/Usermanage/clubmanage',
		name: '部门管理',
		component: () => import('@/pageme/Qitamanage/clubmanage.vue')
	},
	{
		path: '/basicmanage/specialtymange',
		name: '专业管理',
		component: () => import('@/pageme/Qitamanage/specialtymange.vue')
	},
	{
		path: '/Usermanage/classmange',
		name: '班级管理1',
		component: () => import('@/pageme/Qitamanage/classmange.vue')
	},
	{
		path: '/Usermanage/usermange',
		name: '角色管理2',
		component: () => import('@/pageme/Qitamanage/usermange.vue')
	},
	{
		path: '/basicmanage/usermange',
		name: '角色管理',
		component: () => import('@/pageme/Qitamanage/usermange.vue')
	},

	//其他管理
	{
		path: '/qitamanage/shoolmanage',
		name: '院校管理1',
		component: () => import('@/pageme/Qitamanage/shoolmanage.vue')
	},
	{
		path: '/qitamanage/menumange',
		name: '菜单管理2',
		component: () => import('@/pageme/Qitamanage/menumange.vue')
	},
	{
		path: '/qitamanage/clubmanage',
		name: '部门管理1',
		component: () => import('@/pageme/Qitamanage/clubmanage.vue')
	},
	{
		path: '/qitamanage/specialtymange',
		name: '专业管理1',
		component: () => import('@/pageme/Qitamanage/specialtymange.vue')
	},
	{
		path: '/basicmanage/classmange',
		name: '班级管理',
		component: () => import('@/pageme/Qitamanage/classmange.vue')
	},
	{
		path: '/qitamanage/usermange',
		name: '角色管理1',
		component: () => import('@/pageme/Qitamanage/usermange.vue')
	},
	// 权限管理
	{
		path: '/authoritymange/authority',
		name: '权限管理1',
		component: () => import('@/pageme/authoritymange/authority.vue')
	},
	{
		path: '/system/authority',
		name: '权限管理',
		component: () => import('@/pageme/authoritymange/authority.vue')
	},
	// 综合管理
	{
		path: '/device/trainingmange',
		name: '实训室管理',
		component: () => import('@/pageme/allmanage/trainingmange.vue')
	},
	{
		path: '/device/trainingmangesb',
		name: '实训设备管理1',
		component: () => import('@/pageme/allmanage/trainingmangesb.vue')
	},
	{
		path: '/device/addmanges',
		name: '新增实训室',
		component: () => import('@/pageme/allmanage/addmanges.vue')
	},
	{
		path: '/device/roomxq',
		name: '设备详情页面',
		component: () => import('@/pageme/allmanage/roomsxq.vue')
	},
	{
		path: '/device/addmangesb',
		name: '新增设备',
		component: () => import('@/pageme/allmanage/addmangesb.vue')
	},
	{
		path: '/device/sourcemange',
		name: '设备电源管理',
		component: () => import('@/pageme/allmanage/sourcemange.vue')
	},
	{
		path: '/device/addsourcemange',
		name: '增加设备电源',
		component: () => import('@/pageme/allmanage/addsourcemange.vue')
	},
	{
		path: '/device/stiticenotes',
		name: '操作记录',
		component: () => import('@/pageme/allmanage/stiticenotes.vue')
	},
	// 实训管理 进度管理
	{
		path: '/allmanage/trainspressmange',
		name: '实训计划管理',
		component: () => import('@/pageme/allmanage/trainspressmange.vue')
	},
	{
		path: '/allmanage/trainspressmangexq',
		name: '实训计划详情',
		component: () => import('@/pageme/allmanage/trainspressmangexq.vue')
	},
	{
		path: '/allmanage/trainingpractical',
		name: '实训班级档案',
		component: () => import('@/pageme/allmanage/trainingpractical.vue')
	},
	{
		path: '/allmanage/trainingpracticalusers',
		name: '个人实训档案',
		component: () => import('@/pageme/allmanage/trainingpracticalusers.vue')
	},
	{
		path: '/allmanage/trainingpracticalxq',
		name: '实训档案详情',
		component: () => import('@/pageme/allmanage/trainingpracticalxq.vue')
	},
	{
		path: '/allmanage/userabilitymodel',
		name: '实训能力模型',
		component: () => import('@/pageme/allmanage/userabilitymodel.vue')
	},
	{
		path: '/userabilitymodel/userabilitymodel',
		name: '实训能力模型1',
		component: () => import('@/pageme/userabilitymodel/userabilitymodel.vue')
	},
	{
		path: '/allmanage/trainingmange',
		name: '实训室管理1',
		component: () => import('@/pageme/allmanage/trainingmange.vue')
	},
	{
		path: '/allmanage/trainingmangesb',
		name: '实训设备管理',
		component: () => import('@/pageme/allmanage/trainingmangesb.vue')
	},
	{
		path: '/allmanage/addmanges',
		name: '新增实训室1',
		component: () => import('@/pageme/allmanage/addmanges.vue')
	},
	{
		path: '/allmanage/roomxq',
		name: '设备详情页面1',
		component: () => import('@/pageme/allmanage/roomsxq.vue')
	},
	{
		path: '/allmanage/addmangesb',
		name: '新增设备1',
		component: () => import('@/pageme/allmanage/addmangesb.vue')
	},
	{
		path: '/allmanage/sourcemange',
		name: '设备电源管理1',
		component: () => import('@/pageme/allmanage/sourcemange.vue')
	},
	{
		path: '/allmanage/addsourcemange',
		name: '增加设备电源1',
		component: () => import('@/pageme/allmanage/addsourcemange.vue')
	},
	{
		path: '/allmanage/stiticenotes',
		name: '操作记录1',
		component: () => import('@/pageme/allmanage/stiticenotes.vue')
	},
	// 数据分析管理
	{
		path: '/allmanage/orderselete',
		name: '预约实训记录查询',
		component: () => import('@/pageme/information/orderselete.vue')
	},
	{
		path: '/allmanage/statistics',
		name: '数据统计分析',
		component: () => import('@/pageme/information/statistics.vue')
	},
	{
		path: '/information/classstatistics',
		name: '班级数据分析',
		component: () => import('@/pageme/information/classstatistics.vue')
	},
	{
		path: '/information/studenttics',
		name: '学员个人分析',
		component: () => import('@/pageme/information/studenttics.vue')
	},
	{
		path: '/information/devicetatistics',
		name: '设备使用详情',
		component: () => import('@/pageme/information/devicetatistics.vue')
	},
	{
		path: '/system/logmange',
		name: '日志管理1',
		component: () => import('@/pageme/information/logmange.vue')
	},
	{
		path: '/system/systemsrrtting',
		name: '系统设置',
		component: () => import('@/pageme/information/systemsrrtting.vue')
	},
	{
		path: '/information/logmange',
		name: '日志管理',
		component: () => import('@/pageme/information/logmange.vue')
	},
	{
		path: '/informations',
		name: '用户反馈',
		component: () => import('@/pageme/information/tickling.vue')
	},
	{
		path: '/usercenter/informations',
		name: '用户反馈1',
		component: () => import('@/pageme/information/tickling.vue')
	},
	{
		path: '/information/systemsrrtting',
		name: '系统设置1',
		component: () => import('@/pageme/information/systemsrrtting.vue')
	},
	{
		path: '/datawall',
		name: '数据墙',
		component: () => import('@/pageme/datawall.vue')
	},
	// {
	// 	path: '/Intelligentwall',
	// 	name: '智能运维系统',
	// 	component: () => import('@/pageme/datawall/echartswoll.vue')
	// },

	{
		path: '/datawall/datawalluser',
		name: '学院数据分析',
		component: () => import('@/pageme/datawall/datawalluser.vue')
	},
	{
		path: '/datawall/newdatawalluser',
		name: '新的学院数据分析',
		component: () => import('@/pageme/datawall/newdatawalluser.vue')
	},
	// {
	// 	path: '/bs/icons',
	// 	name: '图标库',
	// 	component: () => import('@/pages/Icons.vue')
	// },
	{
		path: '/usercenter/usermanage/trainingpracticalusers',
		name: '我的实训档案',
		component: () => import('@/pageme/Usermanage/trainingpracticalusers.vue')
	},
	{
		path: '/pageme/examine',
		name: '理论考试',
		component: () => import('@/pageme/examine.vue')
	},
	{
		path: '/usercenter/myexaminelist',
		name: '我的考试列表',
		component: () => import('@/pageme/Usermanage/myexaminelist.vue')
	},
	{
		path: '/textorexamin/examinationmanage/examinxq',
		name: '试卷详情',
		component: () => import('@/homesview/examinationmanage/examinxq.vue')
	},
	{
		path: '/textorexamin/examinationmanage/examinxqtwo',
		name: '预览试卷',
		component: () => import('@/homesview/cours/examinxqtwo.vue')
	},
	{
		path: '/textorexamin/examinationmanage/examinkslis',
		name: '考试详情',
		component: () => import('@/homesview/examinationmanage/examinkslis.vue')
	},
	{
		path: '/studyplan/learningmap/learningmapdetil',
		name: '地图详情',
		component: () => import('@/homesview/learningmap/learningmapdetil.vue')
	},
	{
		path: '/studyplan/learningmap/addlearningmap',
		name: '添加地图',
		component: () => import('@/homesview/learningmap/addlearningmap.vue')
	},
	{
		path: '/studyplan/learningmap/editslearningmap',
		name: '编辑地图',
		component: () => import('@/homesview/learningmap/editslearningmap.vue')
	},
	{
		path: '/course/cours/clouddeteamange',
		name: '课程管理预览',
		component: () => import('@/homesview/cours/clouddeteamange.vue')
	},
	{
		path: '/course/cours/editcourse',
		name: '课程管理编辑',
		component: () => import('@/homesview/cours/editcourse.vue')
	},
	{
		path: '/usercenter/homesview/testists/Myexamind',
		name: '我的考试',
		component: () => import('@/homesview/testists/Myexamind.vue')
	},
	{
		path: '/usercenter/Myerrtexts',
		name: '我的错题',
		component: () => import('@/homesview/Myerrtexts.vue')
	},
	{
		path: '/usercenter/Mynotes',
		name: '我的笔记',
		component: () => import('@/homesview/Mynotes.vue')
	},
	{
		path: '/usercenter/Mycolle',
		name: '我的收藏',
		component: () => import('@/homesview/Mycolle.vue')
	},
	// 匹配项目不存在的路由 重定向到404
	{
		path: '/:pathMatch(.*)*',
		redirect: '/inits'
	}
];

export default routes;
</script>
